// @ts-nocheck

import color from 'color';
import React from 'react';
import styled, { css } from 'styled-components';

import logoW112 from '../assets/img/mobile/logo_winamax_112x112.png';
import logoW224 from '../assets/img/mobile/logo_winamax_224x224.png';
import logoW56 from '../assets/img/mobile/logo_winamax_56x56.png';
import { Target, isIOSEmbeddedAndStandalone } from '../client';
import ExpandArrow from '../components/ExpandArrow/ExpandArrow';
import ListItem from '../components/ListItem';
import { NAVBAR_BASE_HEIGHT } from '../constants/ui/navbar';
import { SPORTS_MENU_LIST_ITEM_HEIGHT } from '../constants/ui/sportsMenu';

import theme from './dark';

const colorPrimary = color('#b20e10');
const colorSecondary = color('#ffc514');
const colorLight = color('#dddddd');

export const PrimaryButton = styled.button`
  && {
    border: 0;
    border-radius: 2px;
    padding: 0.6em;
    margin: 0;
    max-width: none;
    font-size: 1em;
    line-height: normal;
    font-weight: 600;
    color: #fff;
    text-align: center;
    box-shadow: inset 0 0.1em 0 rgba(255, 255, 255, 0.5);
    background-color: ${colorPrimary.string()};
    cursor: pointer;
    :focus {
      outline: 0;
    }
    :active {
      background-color: ${colorPrimary.lighten(0.2).string()};
    }
    :disabled {
      opacity: 0.3;
    }
    a {
      color: #fff;
      font-weight: 600;
      outline: none;
      display: inline-block;
      width: 100%;
    }
  }
`;

export const SecondaryButton = styled(PrimaryButton)`
  && {
    color: #333;
    background-color: ${colorSecondary.string()};
    :active {
      background-color: ${colorSecondary.darken(0.2).string()};
    }
    a {
      color: #333;
      outline: none;
    }
  }
`;

export const Button = styled(SecondaryButton)`
  && {
    background-color: ${colorLight.string()};
    :active {
      background-color: ${colorLight.darken(0.2).string()};
    }
  }
`;

export const FlatButton = styled(Button)`
  && {
    box-shadow: none;
    background: none;
    color: #333;
  }
`;

export const AutoScrollAnchor = styled.div`
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  left: 0;
  top: calc(${Target.__MOBILE__ ? -((NAVBAR_BASE_HEIGHT + 0.1) * (isIOSEmbeddedAndStandalone ? 2 : 1)) : 0}em - 0.5em);
`;

export const NewTag = styled.div`
  display: inline-flex;
  color: ${theme.NewTag.color};
  background-color: ${theme.NewTag.backgroundColor};
  font-size: 75%;
  padding: 0.05em 0.3em;
  border-radius: 0.4em;
  align-items: center;
  justify-content: center;
`;

export const ItemListSquare = styled.div`
  color: #fff;
  position: relative;
  padding-left: 1em;

  &:before {
    content: '';
    position: absolute;

    left: 0.3em;
    top: 0em;
    width: 0.3em;
    height: 0.75em;

    background: var(--itemListSquare--color, red);
    transform: translateY(40%);
  }
`;

const LightlyWhiteHeaderBackgroundSC = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0;
  pointer-events: none;
`;

export const LightlyWhiteHeaderBackgroundClassName = 'lightly-white-header-background';
type LightlyWhiteHeaderBackgroundProps = {
  className?: string;
};
export const LightlyWhiteHeaderBackground = ({ className = '' }: LightlyWhiteHeaderBackgroundProps) => (
  <LightlyWhiteHeaderBackgroundSC className={`${className}${LightlyWhiteHeaderBackgroundClassName}`} />
);

export const SwitchIconImg = styled.img`
  object-fit: cover;
  background-repeat: no-repeat;
  height: 1.6em;
  margin-right: 0.5em;
`;

export const BasketRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  ${({ $alignRight }) =>
    $alignRight
      ? css`
          justify-content: flex-end;
        `
      : undefined}

  ${({ $systemBaseRow }) => {
    if ($systemBaseRow) {
      return css`
        margin-bottom: -0.6em;
      `;
    }
  }}
`;

export const MyMatchSelectionCircle = styled.div`
  border-radius: 50%;
  background-color: white;
  width: 0.3em;
  height: 0.3em;
  position: absolute;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  z-index: 1;
  left: 1em;
`;

export const MyMatchCircleWrapper = styled.div`
  overflow: hidden;

  ::after,
  ::before {
    content: '';
    position: absolute;
    width: 1px;
    background-color: white;
    left: 1em;
    transform: translateX(-50%);
  }

  ::before {
    top: 0;
    height: calc(50% - 0.4em);
    transform-origin: 0 100%;
    display: ${({ $noTopLine }) => ($noTopLine ? 'none' : 'initial')};
  }

  ::after {
    top: calc(50% + 0.4em);
    height: calc(50%);
    transform-origin: 0 0;
    display: ${({ $noBottomLine }) => ($noBottomLine ? 'none' : 'initial')};
  }

  :first-child::before,
  :last-child::after {
    display: none;
  }

  ${({ $hasError }) =>
    $hasError
      ? css`
          &::before {
            height: calc(50% - 0.75em);
          }

          &::after {
            top: calc(50% + 0.75em);
            background-color: #f65555;
          }
        `
      : undefined}

  ${({ $hasPreviousError }) =>
    $hasPreviousError
      ? css`
          &::before {
            background-color: #f65555;
          }
        `
      : undefined}
`;

export const BetGroupWrapper = styled.div`
  margin-top: 0.5em;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const BetGroupLabel = styled.div`
  color: ${theme.BetGroupLabel.color};
  margin: 0.6em;
  font-size: 95%;

  &:only-child {
    margin-right: auto;
  }
`;

export const MultiviewBlockWrapper = styled.div`
  height: 100%;
  border-radius: 2px;
  margin: 0 1em 2em 1em;
`;

export const MultiviewButton = styled.button`
  && {
    font-weight: normal;
    background: #e0e1e2;
    padding: 0.625em;
    position: relative;
    display: inline-block;
    color: rgba(0, 0, 0, 0.6);
    min-height: 1em;
    outline: 0;
    border: none;
    border-radius: 2px;
    -webkit-tap-highlight-color: transparent;
    transition:
      0.1s background-color,
      0.1s color;
    cursor: pointer;

    ${Target.__MOBILE__
      ? css`
          :active {
            background: #babbbc;
          }
        `
      : css`
          &:hover {
            background: #cacbcd;
          }
        `}
  }
`;

export const WinamaxLogo = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 2.8em;
  height: 2.8em;
  background-image: url(${logoW56});
  background-repeat: no-repeat;
  background-size: 100% 100%;

  /* stylelint-disable  */
  @media screen and (-webkit-min-device-pixel-ratio: 2),
    screen and (min--moz-device-pixel-ratio: 2),
    screen and (-o-min-device-pixel-ratio: 2/1),
    screen and (min-device-pixel-ratio: 2),
    screen and (min-resolution: 2dppx) {
    background-image: url(${logoW112});
  }
  @media screen and (-webkit-min-device-pixel-ratio: 3),
    screen and (min--moz-device-pixel-ratio: 3),
    screen and (-o-min-device-pixel-ratio: 3/1),
    screen and (min-device-pixel-ratio: 3),
    screen and (min-resolution: 3dppx) {
    background-image: url(${logoW224});
  }
  /* stylelint-enable */
`;

// NB: `pointer-events: none;` is necessary for the VideoPlayer controls to appear otherwhise they don't
export const PiPWrap = styled.div`
  height: 0;
  padding-top: ${({ $isExpand }) => ($isExpand ? '56.25%' : 0)};
  width: 100%;
  position: relative;
  z-index: ${theme.ZIndices.overlay};
  pointer-events: none;
`;

export const SocialMediaButton = styled(Button)`
  width: 3em;
  height: 3em;
  && {
    line-height: 0;
  }
`;

const commonUserNotificationButton = css`
  min-height: 3em;
`;

export const UserNotificationButton = styled(PrimaryButton)`
  ${commonUserNotificationButton}
  && {
    background-color: ${theme.Cgu.acceptBackgroundColor};
    color: ${theme.Cgu.acceptColor};
  }
`;

export const UserNotificationContent = styled.div`
  position: relative;
  width: 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 1em;
  overflow: auto;
`;

export const UserNotificationCloseButton = styled(PrimaryButton)`
  ${commonUserNotificationButton}
  && {
    color: ${theme.Cgu.rejectColor};
    background-color: ${theme.Cgu.rejectBackgroundColor};
  }
`;

export const UserNotificationFetchedContent = styled.div`
  > ul > li {
    margin-bottom: 0.5em;
  }
`;

export const UserNotificationCtaWrapper = styled.div`
  flex: 1;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;

  width: 100%;

  ${({ $backgroundColor }) =>
    $backgroundColor
      ? css`
          background: ${$backgroundColor};
        `
      : undefined}

  > button {
    min-height: 40px;
    width: 100%;
    margin-bottom: 0.5em;
    :last-child {
      margin-bottom: 0;
    }
  }
`;

export const SportsMenuTitleLabel = styled.div`
  font-weight: 600;
  color: ${theme.List.Title.color};
  display: flex;
  align-items: center;
  font-weight: bold;

  font-size: 1.2em;

  ${Target.__MOBILE__
    ? css`
        letter-spacing: normal;
      `
    : css`
        letter-spacing: 0.05em;
      `}

  &:first-letter {
    text-transform: uppercase;
  }

  ${({ $pad }) =>
    $pad
      ? css`
          padding: 0.8em 0;
        `
      : css`
          padding-bottom: 0.5em;
        `}
`;

export const SportsMenuListItem = styled(ListItem)`
  background-image: none;
  padding: 0 0.5em;
  height: ${SPORTS_MENU_LIST_ITEM_HEIGHT}em;
  min-height: 2em;
  border-top: none;

  &:hover {
    ${Target.__MOBILE__
      ? undefined
      : css`
          background-color: ${theme.SportsMenuListItem.hoverColor};
          filter: brightness(110%);
          box-shadow: none;
        `}
  }

  &:active {
    background-color: ${theme.SportsMenuListItem.active.backgroundColor};
    filter: brightness(100%);
  }
`;

export const SportsMenuBtnContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
`;

type SportsMenuBtnLabelProps = {
  $separator?: boolean;
};

export const SportsMenuBtnLabel = styled.div<SportsMenuBtnLabelProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  height: 100%;
  margin-left: 0.5em;

  & > div {
    margin-left: 0.7em;
  }

  border-top: ${({ $separator }) => ($separator ? `1px solid ${theme.SportsMenuListItem.separatorColor}` : undefined)};
`;

export const MenuDesktopArrowIcon = styled(ExpandArrow)`
  position: absolute;
  right: 0.7em;
  height: 1em;
  width: 1em;
  transition: transform 150ms ease-in-out;
  transform: rotate(90deg);

  & .sports-arrow-inner-group {
    stroke: ${theme.SportsMenuListItem.arrowColor};
  }
`;

export const HotTag = styled.div`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.1em 0.1em 0.1em 0.3em;
  margin-right: 0.3em;
  background-color: ${theme.HotEffect.mainEffectColor};
  color: white;

  border-radius: 3px;

  transform: scale(0.95);
  filter: drop-shadow(0 0 0.2em ${theme.HotEffect.mainEffectColor});

  &:before {
    content: '';
    position: absolute;
    height: 100%;
    width: 1em;
    right: -0.8em;
    top: 0;
    bottom: 0;
    background: ${theme.HotEffect.mainEffectColor};
    -webkit-clip-path: polygon(0 0, 0% 100%, 60% 0);
    clip-path: polygon(0 0, 0% 100%, 60% 0);

    z-index: -1;
  }

  &:after {
    content: '';
    position: absolute;
    height: 100%;
    width: 1em;
    right: -0.8em;
    top: 0;
    bottom: 0;
    background: ${theme.HotEffect.mainEffectColor};
    -webkit-clip-path: polygon(0 0, 0% 100%, 60% 100%);
    clip-path: polygon(0 0, 0% 100%, 60% 100%);

    z-index: -1;
  }
`;
